<template>
  <font-awesome-icon icon="spinner-third" spin v-if="isLoading" size="lg" class="text-hint align-self-center" />
  <img v-else :src="src" class="img-fluid" />
</template>

<script>
import client from '@/http-client'
export default {
  props: {
    url: {
      type: [String, Number],
      required: true,
    },
    height: {
      required: false,
    },
  },
  data: () => ({
    src: false,
    isLoading: false,
  }),
  async mounted() {
    this.isLoading = true
    try {
      this.src = this.$helpers.cdnUrl(this.url)
      // const response = await client.get(this.$helpers.cdnUrl(this.url))
      // this.src = response.url
      this.$emit('resolved', this.src)
      this.isLoading = false
    } catch (err) {
      /* gulp */
    }
  },
}
</script>
